@if(!disable){
  <kendo-label class="k-display-block"
               [for]="textbox"
               text="Press the + button to add to list"></kendo-label>
  <kendo-textbox #textbox
                 [style.width.px]="400">
    <ng-template kendoTextBoxSuffixTemplate>
      <button kendoButton fillMode="clear" class="btnAdd" (click)="addItem(textbox)"><fa-icon #icon [icon]="addIcon"></fa-icon></button>
    </ng-template>
  </kendo-textbox>
  <br />
  <br />
}

<kendo-listbox kendoListBoxDataBinding
               class="list-box"
               [data]="itemList"
               [toolbar]="toolbarSettings">
</kendo-listbox>
